import { Directive, inject, OnInit } from '@angular/core';
import { Account } from '@df/account/account.interfaces';
import { NDfAccount } from '@df/account/df-account.config';
import { RequestService } from '@df/api/request/request.service';
import { Status } from '@df/core/status';
import { UiComponent } from '@df/ui/ui.component';

@Directive()
export abstract class AccountV2NavigationComponentDef extends UiComponent implements OnInit {
    /**
     * Navigation items
     */
    navigation!: Account.INavigationItem[];

    /**
     * Logout action status
     */
    readonly logoutStatus = new Status();

    private request = inject(RequestService);
    protected moduleConfig = inject(NDfAccount.OPTIONS);

    /**
     * Intialize
     */
    override ngOnInit(): void {
        this.updateNavigation();
        super.ngOnInit();
    }

    /**
     * Log out
     */
    logout() {
        this.request.send(this.logoutStatus, () => this.request.nexus.customer.logout({}));
    }

    /**
     * Account navigation
     * It is extract to separate method to let us override if we have more complex rule what items to show
     */
    protected updateNavigation() {
        this.navigation = this.moduleConfig.navigation;
    }
}
